import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ui/DMBTGuide.css';

const DMBTGuide = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: t('dmbtGuide.tabs.overview'), icon: '📖' },
    { id: 'methodology', label: t('dmbtGuide.tabs.methodology'), icon: '🔬' },
    { id: 'nodes', label: t('dmbtGuide.tabs.nodes'), icon: '🔵' },
    { id: 'relations', label: t('dmbtGuide.tabs.relations'), icon: '🔗' },
    { id: 'workflow', label: t('dmbtGuide.tabs.workflow'), icon: '⚙️' },
    { id: 'patterns', label: t('dmbtGuide.tabs.patterns'), icon: '🎨' },
    { id: 'benefits', label: t('dmbtGuide.tabs.benefits'), icon: '🎯' },
    { id: 'implementation', label: t('dmbtGuide.tabs.implementation'), icon: '🛠️' },
    { id: 'advanced', label: t('dmbtGuide.tabs.advanced'), icon: '🚀' }
  ];

  const renderOverview = () => (
    <div className="dmbt-content">
      <div className="dmbt-hero">
        <div className="dmbt-hero-icon">🧠</div>
        <h1>{t('dmbtGuide.overview.title')}</h1>
        <p className="dmbt-hero-subtitle">
          {t('dmbtGuide.overview.subtitle')}
        </p>
      </div>
      
      <div className="dmbt-principle">
        <h2>{t('dmbtGuide.overview.principle.title')}</h2>
        <div className="principle-card">
          <p>
            {t('dmbtGuide.overview.principle.description')}
          </p>
          <div className="principle-formula">
            <strong>{t('dmbtGuide.overview.principle.formula')}</strong>
          </div>
        </div>
      </div>

      <div className="dmbt-comparison">
        <h2>{t('dmbtGuide.overview.comparison.title')}</h2>
        <div className="comparison-grid">
          <div className="comparison-item traditional">
            <h3>{t('dmbtGuide.overview.comparison.traditional.title')}</h3>
            <ul>
              <li>{t('dmbtGuide.overview.comparison.traditional.static')}</li>
              <li>{t('dmbtGuide.overview.comparison.traditional.maintenance')}</li>
              <li>{t('dmbtGuide.overview.comparison.traditional.coverage')}</li>
              <li>{t('dmbtGuide.overview.comparison.traditional.lateDetection')}</li>
              <li>{t('dmbtGuide.overview.comparison.traditional.disconnectedTests')}</li>
            </ul>
          </div>
          <div className="comparison-item dmbt">
            <h3>{t('dmbtGuide.overview.comparison.dmbt.title')}</h3>
            <ul>
              <li>{t('dmbtGuide.overview.comparison.dmbt.item1')}</li>
              <li>{t('dmbtGuide.overview.comparison.dmbt.item2')}</li>
              <li>{t('dmbtGuide.overview.comparison.dmbt.item3')}</li>
              <li>{t('dmbtGuide.overview.comparison.dmbt.item4')}</li>
              <li>{t('dmbtGuide.overview.comparison.dmbt.item5')}</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="dmbt-stats">
        <div className="stat-card">
          <div className="stat-number">85%</div>
          <div className="stat-label">{t('dmbtGuide.overview.stats.card1.label')}</div>
          <div className="stat-detail">{t('dmbtGuide.overview.stats.card1.detail')}</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">60%</div>
          <div className="stat-label">{t('dmbtGuide.overview.stats.card2.label')}</div>
          <div className="stat-detail">{t('dmbtGuide.overview.stats.card2.detail')}</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">2x</div>
          <div className="stat-label">{t('dmbtGuide.overview.stats.card3.label')}</div>
          <div className="stat-detail">{t('dmbtGuide.overview.stats.card3.detail')}</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">75%</div>
          <div className="stat-label">{t('dmbtGuide.overview.stats.card4.label')}</div>
          <div className="stat-detail">{t('dmbtGuide.overview.stats.card4.detail')}</div>
        </div>
      </div>
    </div>
  );

  const renderMethodology = () => (
    <div className="dmbt-content">
  <h1>{t('dmbtGuide.methodology.title')}</h1>
      
      <div className="methodology-phases">
  <h2>{t('dmbtGuide.methodology.phases.title')}</h2>
        
        <div className="phase-timeline">
          <div className="phase-item">
            <div className="phase-number">1</div>
            <div className="phase-content">
              <h3>{t('dmbtGuide.methodology.phases.discovery.title')}</h3>
              <p><strong>{t('dmbtGuide.methodology.objectiveLabel')}</strong> {t('dmbtGuide.methodology.phases.discovery.objective')}</p>
              <div className="phase-details">
                <strong>{t('dmbtGuide.methodology.actionsLabel')}</strong>
                <ul>
                  <li>{t('dmbtGuide.methodology.phases.discovery.action1')}</li>
                  <li>{t('dmbtGuide.methodology.phases.discovery.action2')}</li>
                  <li>{t('dmbtGuide.methodology.phases.discovery.action3')}</li>
                  <li>{t('dmbtGuide.methodology.phases.discovery.action4')}</li>
                </ul>
                <strong>{t('dmbtGuide.methodology.deliverablesLabel')}</strong> {t('dmbtGuide.methodology.phases.discovery.deliverables')}
              </div>
            </div>
          </div>

          <div className="phase-item">
            <div className="phase-number">2</div>
            <div className="phase-content">
              <h3>{t('dmbtGuide.methodology.phases.modeling.title')}</h3>
              <p><strong>{t('dmbtGuide.methodology.objectiveLabel')}</strong> {t('dmbtGuide.methodology.phases.modeling.objective')}</p>
              <div className="phase-details">
                <strong>{t('dmbtGuide.methodology.actionsLabel')}</strong>
                <ul>
                  <li>{t('dmbtGuide.methodology.phases.modeling.action1')}</li>
                  <li>{t('dmbtGuide.methodology.phases.modeling.action2')}</li>
                  <li>{t('dmbtGuide.methodology.phases.modeling.action3')}</li>
                  <li>{t('dmbtGuide.methodology.phases.modeling.action4')}</li>
                </ul>
                <strong>{t('dmbtGuide.methodology.deliverablesLabel')}</strong> {t('dmbtGuide.methodology.phases.modeling.deliverables')}
              </div>
            </div>
          </div>

          <div className="phase-item">
            <div className="phase-number">3</div>
            <div className="phase-content">
              <h3>{t('dmbtGuide.methodology.phases.collection.title')}</h3>
              <p><strong>{t('dmbtGuide.methodology.objectiveLabel')}</strong> {t('dmbtGuide.methodology.phases.collection.objective')}</p>
              <div className="phase-details">
                <strong>{t('dmbtGuide.methodology.actionsLabel')}</strong>
                <ul>
                  <li>{t('dmbtGuide.methodology.phases.collection.action1')}</li>
                  <li>{t('dmbtGuide.methodology.phases.collection.action2')}</li>
                  <li>{t('dmbtGuide.methodology.phases.collection.action3')}</li>
                  <li>{t('dmbtGuide.methodology.phases.collection.action4')}</li>
                </ul>
                <strong>{t('dmbtGuide.methodology.deliverablesLabel')}</strong> {t('dmbtGuide.methodology.phases.collection.deliverables')}
              </div>
            </div>
          </div>

          <div className="phase-item">
            <div className="phase-number">4</div>
            <div className="phase-content">
              <h3>{t('dmbtGuide.methodology.phases.ai.title')}</h3>
              <p><strong>{t('dmbtGuide.methodology.objectiveLabel')}</strong> {t('dmbtGuide.methodology.phases.ai.objective')}</p>
              <div className="phase-details">
                <strong>{t('dmbtGuide.methodology.actionsLabel')}</strong>
                <ul>
                  <li>{t('dmbtGuide.methodology.phases.ai.action1')}</li>
                  <li>{t('dmbtGuide.methodology.phases.ai.action2')}</li>
                  <li>{t('dmbtGuide.methodology.phases.ai.action3')}</li>
                  <li>{t('dmbtGuide.methodology.phases.ai.action4')}</li>
                </ul>
                <strong>{t('dmbtGuide.methodology.deliverablesLabel')}</strong> {t('dmbtGuide.methodology.phases.ai.deliverables')}
              </div>
            </div>
          </div>

          <div className="phase-item">
            <div className="phase-number">5</div>
            <div className="phase-content">
              <h3>{t('dmbtGuide.methodology.phases.evolution.title')}</h3>
              <p><strong>{t('dmbtGuide.methodology.objectiveLabel')}</strong> {t('dmbtGuide.methodology.phases.evolution.objective')}</p>
              <div className="phase-details">
                <strong>{t('dmbtGuide.methodology.actionsLabel')}</strong>
                <ul>
                  <li>{t('dmbtGuide.methodology.phases.evolution.action1')}</li>
                  <li>{t('dmbtGuide.methodology.phases.evolution.action2')}</li>
                  <li>{t('dmbtGuide.methodology.phases.evolution.action3')}</li>
                  <li>{t('dmbtGuide.methodology.phases.evolution.action4')}</li>
                </ul>
                <strong>{t('dmbtGuide.methodology.deliverablesLabel')}</strong> {t('dmbtGuide.methodology.phases.evolution.deliverables')}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="methodology-best-practices">
        <h2>{t('dmbtGuide.methodology.bestPractices.title')}</h2>
        <div className="best-practices-grid">
          <div className="practice-card">
            <div className="practice-icon">📈</div>
            <h3>{t('dmbtGuide.methodology.bestPractices.startSmall.title')}</h3>
            <p>{t('dmbtGuide.methodology.bestPractices.startSmall.desc')}</p>
          </div>
          <div className="practice-card">
            <div className="practice-icon">👥</div>
            <h3>{t('dmbtGuide.methodology.bestPractices.crossFunctional.title')}</h3>
            <p>{t('dmbtGuide.methodology.bestPractices.crossFunctional.desc')}</p>
          </div>
          <div className="practice-card">
            <div className="practice-icon">📊</div>
            <h3>{t('dmbtGuide.methodology.bestPractices.dataDriven.title')}</h3>
            <p>{t('dmbtGuide.methodology.bestPractices.dataDriven.desc')}</p>
          </div>
          <div className="practice-card">
            <div className="practice-icon">🔄</div>
            <h3>{t('dmbtGuide.methodology.bestPractices.feedback.title')}</h3>
            <p>{t('dmbtGuide.methodology.bestPractices.feedback.desc')}</p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderNodes = () => (
    <div className="dmbt-content">
      <h1>{t('dmbtGuide.nodes.title')}</h1>
      
      <div className="node-explanation">
        <h2>{t('dmbtGuide.nodes.whatIs.title')}</h2>
        <p>{t('dmbtGuide.nodes.whatIs.description')}</p>
        
        <div className="node-anatomy">
          <div className="anatomy-card">
            <h3>{t('dmbtGuide.nodes.anatomy.title')}</h3>
            <div className="anatomy-details">
              <div className="anatomy-item">
                <strong>{t('dmbtGuide.nodes.anatomy.identity.title')}:</strong> {t('dmbtGuide.nodes.anatomy.identity.description')}
              </div>
              <div className="anatomy-item">
                <strong>{t('dmbtGuide.nodes.anatomy.interfaces.title')}:</strong> {t('dmbtGuide.nodes.anatomy.interfaces.description')}
              </div>
              <div className="anatomy-item">
                <strong>{t('dmbtGuide.nodes.anatomy.metrics.title')}:</strong> {t('dmbtGuide.nodes.anatomy.metrics.description')}
              </div>
              <div className="anatomy-item">
                <strong>{t('dmbtGuide.nodes.anatomy.context.title')}:</strong> {t('dmbtGuide.nodes.anatomy.context.description')}
              </div>
            </div>
          </div>
        </div>
        
        <div className="node-types">
          <h3>{t('dmbtGuide.nodes.types.title')}</h3>
          <div className="node-type-grid">
            <div className="node-type-card action">
              <div className="node-icon">�</div>
              <h4>{t('dmbtGuide.nodes.types.action.title')}</h4>
              <p><strong>{t('dmbtGuide.nodes.types.action.examples')}</strong></p>
              <div className="node-details">
                <strong>{t('dmbtGuide.nodes.types.action.characteristics.title')}:</strong>
                <ul>
                  <li>{t('dmbtGuide.nodes.types.action.characteristics.stateChange')}</li>
                  <li>{t('dmbtGuide.nodes.types.action.characteristics.canFail')}</li>
                  <li>{t('dmbtGuide.nodes.types.action.characteristics.observable')}</li>
                </ul>
              </div>
            </div>
            
            <div className="node-type-card state">
              <div className="node-icon">📊</div>
              <h4>{t('dmbtGuide.nodes.types.state.title')}</h4>
              <p><strong>{t('dmbtGuide.nodes.types.state.examples')}</strong></p>
              <div className="node-details">
                <strong>{t('dmbtGuide.nodes.types.state.characteristics.title')}:</strong>
                <ul>
                  <li>{t('dmbtGuide.nodes.types.state.characteristics.represents')}</li>
                  <li>{t('dmbtGuide.nodes.types.state.characteristics.transient')}</li>
                  <li>{t('dmbtGuide.nodes.types.state.characteristics.influences')}</li>
                </ul>
              </div>
            </div>
            
            <div className="node-type-card decision">
              <div className="node-icon">🔀</div>
              <h4>{t('dmbtGuide.nodes.types.decision.title')}</h4>
              <p><strong>{t('dmbtGuide.nodes.types.decision.examples')}</strong></p>
              <div className="node-details">
                <strong>{t('dmbtGuide.nodes.types.decision.characteristics.title')}:</strong>
                <ul>
                  <li>{t('dmbtGuide.nodes.types.decision.characteristics.evaluates')}</li>
                  <li>{t('dmbtGuide.nodes.types.decision.characteristics.routes')}</li>
                  <li>{t('dmbtGuide.nodes.types.decision.characteristics.complex')}</li>
                </ul>
              </div>
            </div>
            
            <div className="node-type-card data">
              <div className="node-icon">💾</div>
              <h4>{t('dmbtGuide.nodes.types.data.title')}</h4>
              <p><strong>{t('dmbtGuide.nodes.types.data.examples')}</strong></p>
              <div className="node-details">
                <strong>{t('dmbtGuide.nodes.types.data.characteristics.title')}:</strong>
                <ul>
                  <li>{t('dmbtGuide.nodes.types.data.characteristics.stores')}</li>
                  <li>{t('dmbtGuide.nodes.types.data.characteristics.constraints')}</li>
                  <li>{t('dmbtGuide.nodes.types.data.characteristics.influences')}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="node-lifecycle">
        <h2>{t('dmbtGuide.nodes.lifecycle.title')}</h2>
        <div className="lifecycle-stages">
          <div className="stage">
            <div className="stage-icon">🌱</div>
            <h3>{t('dmbtGuide.nodes.lifecycle.creation.title')}</h3>
            <p>{t('dmbtGuide.nodes.lifecycle.creation.desc')}</p>
          </div>
          <div className="stage-arrow">→</div>
          <div className="stage">
            <div className="stage-icon">📊</div>
            <h3>{t('dmbtGuide.nodes.lifecycle.instrumentation.title')}</h3>
            <p>{t('dmbtGuide.nodes.lifecycle.instrumentation.desc')}</p>
          </div>
          <div className="stage-arrow">→</div>
          <div className="stage">
            <div className="stage-icon">🧠</div>
            <h3>{t('dmbtGuide.nodes.lifecycle.learning.title')}</h3>
            <p>{t('dmbtGuide.nodes.lifecycle.learning.desc')}</p>
          </div>
          <div className="stage-arrow">→</div>
          <div className="stage">
            <div className="stage-icon">⚡</div>
            <h3>{t('dmbtGuide.nodes.lifecycle.optimization.title')}</h3>
            <p>{t('dmbtGuide.nodes.lifecycle.optimization.desc')}</p>
          </div>
        </div>
      </div>

      <div className="node-example">
        <h2 className='node-example-title'>{t('dmbtGuide.nodes.example.title')}</h2>
        <div className="code-example">
          <pre>{t('dmbtGuide.nodes.example.loginCode')}</pre>
        </div>
      </div>

      <div className="node-benefits">
        <h2>{t('dmbtGuide.nodes.modelingBenefits.title')}</h2>
        <div className="benefits-grid">
          <div className="benefit-item">
            <span className="benefit-icon">🔍</span>
            <strong>{t('dmbtGuide.nodes.modelingBenefits.fineGranularity.title')}</strong> : {t('dmbtGuide.nodes.modelingBenefits.fineGranularity.description')}
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">🔄</span>
            <strong>{t('dmbtGuide.nodes.modelingBenefits.reusability.title')}</strong> : {t('dmbtGuide.nodes.modelingBenefits.reusability.description')}
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">📈</span>
            <strong>{t('dmbtGuide.nodes.modelingBenefits.contextualMetrics.title')}</strong> : {t('dmbtGuide.nodes.modelingBenefits.contextualMetrics.description')}
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">🎯</span>
            <strong>{t('dmbtGuide.nodes.modelingBenefits.problemIsolation.title')}</strong> : {t('dmbtGuide.nodes.modelingBenefits.problemIsolation.description')}
          </div>
        </div>
      </div>
    </div>
  );

  const renderRelations = () => (
    <div className="dmbt-content">
      <h1>{t('dmbtGuide.relations.title')}</h1>
      
      <div className="relation-types">
        <h2>{t('dmbtGuide.relations.types.title')}</h2>
        <div className="relation-cards">
          <div className="relation-card">
            <div className="relation-icon">📈</div>
            <h3>{t('dmbtGuide.relations.types.sequential.title')}</h3>
            <p>{t('dmbtGuide.relations.types.sequential.description')}</p>
          </div>
          <div className="relation-card">
            <div className="relation-icon">🔀</div>
            <h3>{t('dmbtGuide.relations.types.conditional.title')}</h3>
            <p>{t('dmbtGuide.relations.types.conditional.description')}</p>
          </div>
          <div className="relation-card">
            <div className="relation-icon">🔄</div>
            <h3>{t('dmbtGuide.relations.types.cyclic.title')}</h3>
            <p>{t('dmbtGuide.relations.types.cyclic.description')}</p>
          </div>
          <div className="relation-card">
            <div className="relation-icon">⚡</div>
            <h3>{t('dmbtGuide.relations.types.parallel.title')}</h3>
            <p>{t('dmbtGuide.relations.types.parallel.description')}</p>
          </div>
        </div>
      </div>

      <div className="relation-metadata">
        <h2>{t('dmbtGuide.relations.metadata.title')}</h2>
        <div className="metadata-list">
          <div className="metadata-item">
            <strong>{t('dmbtGuide.relations.metadata.probability.title')}</strong> : {t('dmbtGuide.relations.metadata.probability.description')}
          </div>
          <div className="metadata-item">
            <strong>{t('dmbtGuide.relations.metadata.conditions.title')}</strong> : {t('dmbtGuide.relations.metadata.conditions.description')}
          </div>
          <div className="metadata-item">
            <strong>{t('dmbtGuide.relations.metadata.weight.title')}</strong> : {t('dmbtGuide.relations.metadata.weight.description')}
          </div>
          <div className="metadata-item">
            <strong>{t('dmbtGuide.relations.metadata.timing.title')}</strong> : {t('dmbtGuide.relations.metadata.timing.description')}
          </div>
        </div>
      </div>
    </div>
  );

  const renderWorkflow = () => (
    <div className="dmbt-content">
      <h1>{t('dmbtGuide.workflow.title')}</h1>
      
      <div className="workflow-steps">
        <div className="workflow-step">
          <div className="step-number">1</div>
          <div className="step-content">
            <h3>{t('dmbtGuide.workflow.steps.step1.title')}</h3>
            <p>{t('dmbtGuide.workflow.steps.step1.description')}</p>
          </div>
        </div>
        
        <div className="workflow-step">
          <div className="step-number">2</div>
          <div className="step-content">
            <h3>{t('dmbtGuide.workflow.steps.step2.title')}</h3>
            <p>{t('dmbtGuide.workflow.steps.step2.description')}</p>
          </div>
        </div>
        
        <div className="workflow-step">
          <div className="step-number">3</div>
          <div className="step-content">
            <h3>{t('dmbtGuide.workflow.steps.step3.title')}</h3>
            <p>{t('dmbtGuide.workflow.steps.step3.description')}</p>
          </div>
        </div>
        
        <div className="workflow-step">
          <div className="step-number">4</div>
          <div className="step-content">
            <h3>{t('dmbtGuide.workflow.steps.step4.title')}</h3>
            <p>{t('dmbtGuide.workflow.steps.step4.description')}</p>
          </div>
        </div>
      </div>

      <div className="use-cases">
        <h2>{t('dmbtGuide.workflow.useCases.title')}</h2>
        <div className="use-case-tabs">
          <div className="use-case">
            <h3>{t('dmbtGuide.workflow.useCases.ecommerce.title')}</h3>
            <div className="flow-diagram">
              {t('dmbtGuide.workflow.useCases.ecommerce.flow')}
            </div>
          </div>
          <div className="use-case">
            <h3>{t('dmbtGuide.workflow.useCases.banking.title')}</h3>
            <div className="flow-diagram">
              {t('dmbtGuide.workflow.useCases.banking.flow')}
            </div>
          </div>
          <div className="use-case">
            <h3>{t('dmbtGuide.workflow.useCases.social.title')}</h3>
            <div className="flow-diagram">
              {t('dmbtGuide.workflow.useCases.social.flow')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderPatterns = () => (
    <div className="dmbt-content">
  <h1>{t('dmbtGuide.patterns.title')}</h1>
      
      <div className="patterns-intro">
  <p>{t('dmbtGuide.patterns.intro')}</p>
      </div>

      <div className="patterns-catalog">
  <h2>{t('dmbtGuide.patterns.catalog.title')}</h2>
        
  <div className="pattern-card">
          <div className="pattern-header">
            <div className="pattern-icon">🌊</div>
            <h3>Flow-Based Pattern</h3>
            <div className="pattern-tag">Structural</div>
          </div>
          <div className="pattern-content">
            <div className="pattern-problem">
              <strong>{t('dmbtGuide.patterns.flow.problemLabel')}</strong> {t('dmbtGuide.patterns.flow.problem')}
            </div>
            <div className="pattern-solution">
              <strong>{t('dmbtGuide.patterns.flow.solutionLabel')}</strong> {t('dmbtGuide.patterns.flow.solution')}
            </div>
            <div className="pattern-example">
              <strong>{t('dmbtGuide.patterns.flow.useCaseLabel')}</strong> {t('dmbtGuide.patterns.flow.useCase')}
            </div>
            <div className="pattern-benefits">
              <strong>{t('dmbtGuide.patterns.flow.benefitsLabel')}</strong>
              <ul>
                <li>{t('dmbtGuide.patterns.flow.benefit1')}</li>
                <li>{t('dmbtGuide.patterns.flow.benefit2')}</li>
                <li>{t('dmbtGuide.patterns.flow.benefit3')}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pattern-card">
          <div className="pattern-header">
            <div className="pattern-icon">🔄</div>
            <h3>State Machine Pattern</h3>
            <div className="pattern-tag">Behavioral</div>
          </div>
          <div className="pattern-content">
            <div className="pattern-problem">
              <strong>{t('dmbtGuide.patterns.state.problemLabel')}</strong> {t('dmbtGuide.patterns.state.problem')}
            </div>
            <div className="pattern-solution">
              <strong>{t('dmbtGuide.patterns.state.solutionLabel')}</strong> {t('dmbtGuide.patterns.state.solution')}
            </div>
            <div className="pattern-example">
              <strong>{t('dmbtGuide.patterns.state.useCaseLabel')}</strong> {t('dmbtGuide.patterns.state.useCase')}
            </div>
            <div className="pattern-benefits">
              <strong>{t('dmbtGuide.patterns.state.benefitsLabel')}</strong>
              <ul>
                <li>{t('dmbtGuide.patterns.state.benefit1')}</li>
                <li>{t('dmbtGuide.patterns.state.benefit2')}</li>
                <li>{t('dmbtGuide.patterns.state.benefit3')}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pattern-card">
          <div className="pattern-header">
            <div className="pattern-icon">🎯</div>
            <h3>Adaptive Testing Pattern</h3>
            <div className="pattern-tag">Intelligent</div>
          </div>
          <div className="pattern-content">
            <div className="pattern-problem">
              <strong>{t('dmbtGuide.patterns.adaptive.problemLabel')}</strong> {t('dmbtGuide.patterns.adaptive.problem')}
            </div>
            <div className="pattern-solution">
              <strong>{t('dmbtGuide.patterns.adaptive.solutionLabel')}</strong> {t('dmbtGuide.patterns.adaptive.solution')}
            </div>
            <div className="pattern-example">
              <strong>{t('dmbtGuide.patterns.adaptive.useCaseLabel')}</strong> {t('dmbtGuide.patterns.adaptive.useCase')}
            </div>
            <div className="pattern-benefits">
              <strong>{t('dmbtGuide.patterns.adaptive.benefitsLabel')}</strong>
              <ul>
                <li>{t('dmbtGuide.patterns.adaptive.benefit1')}</li>
                <li>{t('dmbtGuide.patterns.adaptive.benefit2')}</li>
                <li>{t('dmbtGuide.patterns.adaptive.benefit3')}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pattern-card">
          <div className="pattern-header">
            <div className="pattern-icon">🔮</div>
            <h3>Predictive Analysis Pattern</h3>
            <div className="pattern-tag">Predictive</div>
          </div>
          <div className="pattern-content">
            <div className="pattern-problem">
              <strong>{t('dmbtGuide.patterns.predictive.problemLabel')}</strong> {t('dmbtGuide.patterns.predictive.problem')}
            </div>
            <div className="pattern-solution">
              <strong>{t('dmbtGuide.patterns.predictive.solutionLabel')}</strong> {t('dmbtGuide.patterns.predictive.solution')}
            </div>
            <div className="pattern-example">
              <strong>{t('dmbtGuide.patterns.predictive.useCaseLabel')}</strong> {t('dmbtGuide.patterns.predictive.useCase')}
            </div>
            <div className="pattern-benefits">
              <strong>{t('dmbtGuide.patterns.predictive.benefitsLabel')}</strong>
              <ul>
                <li>{t('dmbtGuide.patterns.predictive.benefit1')}</li>
                <li>{t('dmbtGuide.patterns.predictive.benefit2')}</li>
                <li>{t('dmbtGuide.patterns.predictive.benefit3')}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pattern-card">
          <div className="pattern-header">
            <div className="pattern-icon">🏗️</div>
            <h3>Hierarchical Modeling Pattern</h3>
            <div className="pattern-tag">Structural</div>
          </div>
          <div className="pattern-content">
            <div className="pattern-problem">
              <strong>{t('dmbtGuide.patterns.hierarchical.problemLabel')}</strong> {t('dmbtGuide.patterns.hierarchical.problem')}
            </div>
            <div className="pattern-solution">
              <strong>{t('dmbtGuide.patterns.hierarchical.solutionLabel')}</strong> {t('dmbtGuide.patterns.hierarchical.solution')}
            </div>
            <div className="pattern-example">
              <strong>{t('dmbtGuide.patterns.hierarchical.useCaseLabel')}</strong> {t('dmbtGuide.patterns.hierarchical.useCase')}
            </div>
            <div className="pattern-benefits">
              <strong>{t('dmbtGuide.patterns.hierarchical.benefitsLabel')}</strong>
              <ul>
                <li>{t('dmbtGuide.patterns.hierarchical.benefit1')}</li>
                <li>{t('dmbtGuide.patterns.hierarchical.benefit2')}</li>
                <li>{t('dmbtGuide.patterns.hierarchical.benefit3')}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="patterns-implementation">
    <h2>{t('dmbtGuide.implementation.title')}</h2>
        <div className="implementation-steps">
          <div className="step-card">
            <div className="step-number">1</div>
            <div className="step-content">
      <h3>{t('dmbtGuide.implementation.steps.step1.title')}</h3>
      <p>{t('dmbtGuide.implementation.steps.step1.description')}</p>
            </div>
          </div>
          <div className="step-card">
            <div className="step-number">2</div>
            <div className="step-content">
      <h3>{t('dmbtGuide.implementation.steps.step2.title')}</h3>
      <p>{t('dmbtGuide.implementation.steps.step2.description')}</p>
            </div>
          </div>
          <div className="step-card">
            <div className="step-number">3</div>
            <div className="step-content">
      <h3>{t('dmbtGuide.implementation.steps.step3.title')}</h3>
      <p>{t('dmbtGuide.implementation.steps.step3.description')}</p>
            </div>
          </div>
          <div className="step-card">
            <div className="step-number">4</div>
            <div className="step-content">
      <h3>{t('dmbtGuide.implementation.steps.step4.title')}</h3>
      <p>{t('dmbtGuide.implementation.steps.step4.description')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderBenefits = () => (
    <div className="dmbt-content">
      <h1>{t('dmbtGuide.benefits.title')}</h1>
      
      <div className="benefits-overview">
        <div className="benefit-hero">
          <h2>{t('dmbtGuide.benefits.hero.title')}</h2>
          <p>{t('dmbtGuide.benefits.hero.description')}</p>
        </div>
      </div>
      
      <div className="benefits-section">
  <h2>{t('dmbtGuide.benefits.rolesTitle')}</h2>
        
        <div className="role-benefits">
          <div className="role-card testers">
            <div className="role-header">
              <div className="role-icon">🎯</div>
              <h3>{t('dmbtGuide.benefits.roles.testers.title')}</h3>
              <div className="role-badge">{t('dmbtGuide.benefits.roles.testers.badge')}</div>
            </div>
            <div className="role-content">
              <div className="benefit-category">
                <h4>{t('dmbtGuide.benefits.roles.testers.category1.title')}</h4>
                <ul>
                  <li><strong>{t('dmbtGuide.benefits.roles.testers.category1.item1.bold')}</strong> {t('dmbtGuide.benefits.roles.testers.category1.item1')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.testers.category1.item2.bold')}</strong> {t('dmbtGuide.benefits.roles.testers.category1.item2')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.testers.category1.item3.bold')}</strong> {t('dmbtGuide.benefits.roles.testers.category1.item3')}</li>
                </ul>
              </div>
              <div className="benefit-category">
                <h4>{t('dmbtGuide.benefits.roles.testers.category2.title')}</h4>
                <ul>
                  <li><strong>{t('dmbtGuide.benefits.roles.testers.category2.item1.bold')}</strong> {t('dmbtGuide.benefits.roles.testers.category2.item1')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.testers.category2.item2.bold')}</strong> {t('dmbtGuide.benefits.roles.testers.category2.item2')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.testers.category2.item3.bold')}</strong> {t('dmbtGuide.benefits.roles.testers.category2.item3')}</li>
                </ul>
              </div>
              <div className="benefit-metric">
                <div className="metric-number">{t('dmbtGuide.benefits.roles.testers.metric.number')}</div>
                <div className="metric-label">{t('dmbtGuide.benefits.roles.testers.metric.label')}</div>
              </div>
            </div>
          </div>
          
          <div className="role-card product-owners">
            <div className="role-header">
              <div className="role-icon">👨‍💼</div>
              <h3>{t('dmbtGuide.benefits.roles.productOwners.title')}</h3>
              <div className="role-badge">{t('dmbtGuide.benefits.roles.productOwners.badge')}</div>
            </div>
            <div className="role-content">
              <div className="benefit-category">
                <h4>{t('dmbtGuide.benefits.roles.productOwners.category1.title')}</h4>
                <ul>
                  <li><strong>{t('dmbtGuide.benefits.roles.productOwners.category1.item1.bold')}</strong> {t('dmbtGuide.benefits.roles.productOwners.category1.item1')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.productOwners.category1.item2.bold')}</strong> {t('dmbtGuide.benefits.roles.productOwners.category1.item2')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.productOwners.category1.item3.bold')}</strong> {t('dmbtGuide.benefits.roles.productOwners.category1.item3')}</li>
                </ul>
              </div>
              <div className="benefit-category">
                <h4>{t('dmbtGuide.benefits.roles.productOwners.category2.title')}</h4>
                <ul>
                  <li><strong>{t('dmbtGuide.benefits.roles.productOwners.category2.item1.bold')}</strong> {t('dmbtGuide.benefits.roles.productOwners.category2.item1')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.productOwners.category2.item2.bold')}</strong> {t('dmbtGuide.benefits.roles.productOwners.category2.item2')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.productOwners.category2.item3.bold')}</strong> {t('dmbtGuide.benefits.roles.productOwners.category2.item3')}</li>
                </ul>
              </div>
              <div className="benefit-metric">
                <div className="metric-number">{t('dmbtGuide.benefits.roles.productOwners.metric.number')}</div>
                <div className="metric-label">{t('dmbtGuide.benefits.roles.productOwners.metric.label')}</div>
              </div>
            </div>
          </div>
          
          <div className="role-card developers">
            <div className="role-header">
              <div className="role-icon">👨‍💻</div>
              <h3>{t('dmbtGuide.benefits.roles.developers.title')}</h3>
              <div className="role-badge">{t('dmbtGuide.benefits.roles.developers.badge')}</div>
            </div>
            <div className="role-content">
              <div className="benefit-category">
                <h4>{t('dmbtGuide.benefits.roles.developers.category1.title')}</h4>
                <ul>
                  <li><strong>{t('dmbtGuide.benefits.roles.developers.category1.item1.bold')}</strong> {t('dmbtGuide.benefits.roles.developers.category1.item1')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.developers.category1.item2.bold')}</strong> {t('dmbtGuide.benefits.roles.developers.category1.item2')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.developers.category1.item3.bold')}</strong> {t('dmbtGuide.benefits.roles.developers.category1.item3')}</li>
                </ul>
              </div>
              <div className="benefit-category">
                <h4>{t('dmbtGuide.benefits.roles.developers.category2.title')}</h4>
                <ul>
                  <li><strong>{t('dmbtGuide.benefits.roles.developers.category2.item1.bold')}</strong> {t('dmbtGuide.benefits.roles.developers.category2.item1')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.developers.category2.item2.bold')}</strong> {t('dmbtGuide.benefits.roles.developers.category2.item2')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.developers.category2.item3.bold')}</strong> {t('dmbtGuide.benefits.roles.developers.category2.item3')}</li>
                </ul>
              </div>
              <div className="benefit-metric">
                <div className="metric-number">{t('dmbtGuide.benefits.roles.developers.metric.number')}</div>
                <div className="metric-label">{t('dmbtGuide.benefits.roles.developers.metric.label')}</div>
              </div>
            </div>
          </div>

          <div className="role-card management">
            <div className="role-header">
              <div className="role-icon">🏢</div>
              <h3>{t('dmbtGuide.benefits.roles.management.title')}</h3>
              <div className="role-badge">{t('dmbtGuide.benefits.roles.management.badge')}</div>
            </div>
            <div className="role-content">
              <div className="benefit-category">
                <h4>{t('dmbtGuide.benefits.roles.management.category1.title')}</h4>
                <ul>
                  <li><strong>{t('dmbtGuide.benefits.roles.management.category1.item1.bold')}</strong> {t('dmbtGuide.benefits.roles.management.category1.item1')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.management.category1.item2.bold')}</strong> {t('dmbtGuide.benefits.roles.management.category1.item2')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.management.category1.item3.bold')}</strong> {t('dmbtGuide.benefits.roles.management.category1.item3')}</li>
                </ul>
              </div>
              <div className="benefit-category">
                <h4>{t('dmbtGuide.benefits.roles.management.category2.title')}</h4>
                <ul>
                  <li><strong>{t('dmbtGuide.benefits.roles.management.category2.item1.bold')}</strong> {t('dmbtGuide.benefits.roles.management.category2.item1')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.management.category2.item2.bold')}</strong> {t('dmbtGuide.benefits.roles.management.category2.item2')}</li>
                  <li><strong>{t('dmbtGuide.benefits.roles.management.category2.item3.bold')}</strong> {t('dmbtGuide.benefits.roles.management.category2.item3')}</li>
                </ul>
              </div>
              <div className="benefit-metric">
                <div className="metric-number">{t('dmbtGuide.benefits.roles.management.metric.number')}</div>
                <div className="metric-label">{t('dmbtGuide.benefits.roles.management.metric.label')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="benefits-comparison">
  <h2>{t('dmbtGuide.benefits.comparisonTitle')}</h2>
        <div className="comparison-table">
          <div className="comparison-header">
            <div className="comparison-aspect">{t('dmbtGuide.benefits.comparison.aspectLabel')}</div>
            <div className="comparison-before"> {t('dmbtGuide.benefits.comparison.beforeLabel')}</div>
            <div className="comparison-after"> {t('dmbtGuide.benefits.comparison.afterLabel')}</div>
          </div>
          
          <div className="comparison-row">
            <div className="comparison-aspect">{t('dmbtGuide.benefits.comparison.coverageLabel')}</div>
            <div className="comparison-before">{t('dmbtGuide.benefits.dataApproach.before')}</div>
            <div className="comparison-after">{t('dmbtGuide.benefits.dataApproach.after')}</div>
          </div>
          
          <div className="comparison-row">
            <div className="comparison-aspect">{t('dmbtGuide.benefits.comparison.maintenanceLabel')}</div>
            <div className="comparison-before">{t('dmbtGuide.benefits.comparison.maintenance.before')}</div>
            <div className="comparison-after">{t('dmbtGuide.benefits.comparison.maintenance.after')}</div>
          </div>
          
          <div className="comparison-row">
            <div className="comparison-aspect">{t('dmbtGuide.benefits.comparison.detectionLabel')}</div>
            <div className="comparison-before">{t('dmbtGuide.benefits.comparison.detection.before')}</div>
            <div className="comparison-after">{t('dmbtGuide.benefits.comparison.detection.after')}</div>
          </div>
          
          <div className="comparison-row">
            <div className="comparison-aspect">{t('dmbtGuide.benefits.comparison.roiLabel')}</div>
            <div className="comparison-before">{t('dmbtGuide.benefits.comparison.roi.before')}</div>
            <div className="comparison-after">{t('dmbtGuide.benefits.comparison.roi.after')}</div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderImplementation = () => (
    <div className="dmbt-content">
      <h1>{t('dmbtGuide.implementation.title')}</h1>
      
      <div className="dashboard-widgets">
        <h2>{t('dmbtGuide.implementation.widgetsTitle')}</h2>
        <div className="widget-grid">
          <div className="widget-card">
            <div className="widget-icon">🗺️</div>
            <h3>{t('dmbtGuide.implementation.widgets.graph.title')}</h3>
            <p>{t('dmbtGuide.implementation.widgets.graph.description')}</p>
          </div>
          <div className="widget-card">
            <div className="widget-icon">📈</div>
            <h3>{t('dmbtGuide.implementation.widgets.metrics.title')}</h3>
            <p>{t('dmbtGuide.implementation.widgets.metrics.description')}</p>
          </div>
          <div className="widget-card">
            <div className="widget-icon">🎯</div>
            <h3>{t('dmbtGuide.implementation.widgets.coverage.title')}</h3>
            <p>{t('dmbtGuide.implementation.widgets.coverage.description')}</p>
          </div>
          <div className="widget-card">
            <div className="widget-icon">⚡</div>
            <h3>{t('dmbtGuide.implementation.widgets.insights.title')}</h3>
            <p>{t('dmbtGuide.implementation.widgets.insights.description')}</p>
          </div>
        </div>
      </div>

      <div className="roadmap">
        <h2>{t('dmbtGuide.implementation.roadmapTitle')}</h2>
        <div className="phases">
          <div className="phase">
            <h3>{t('dmbtGuide.implementation.roadmap.phases.phase1.title')}</h3>
            <div className="phase-items">
              <div className="phase-item completed">{t('dmbtGuide.implementation.roadmap.phases.phase1.item1')}</div>
              <div className="phase-item completed">{t('dmbtGuide.implementation.roadmap.phases.phase1.item2')}</div>
              <div className="phase-item completed">{t('dmbtGuide.implementation.roadmap.phases.phase1.item3')}</div>
            </div>
          </div>
          <div className="phase">
            <h3>{t('dmbtGuide.implementation.roadmap.phases.phase2.title')}</h3>
            <div className="phase-items">
              <div className="phase-item in-progress">{t('dmbtGuide.implementation.roadmap.phases.phase2.item1')}</div>
              <div className="phase-item in-progress">{t('dmbtGuide.implementation.roadmap.phases.aiDriven.anomalyDetection')}</div>
              <div className="phase-item in-progress">{t('dmbtGuide.implementation.roadmap.phases.phase2.item3')}</div>
            </div>
          </div>
          <div className="phase">
            <h3>{t('dmbtGuide.implementation.roadmap.phases.phase3.title')}</h3>
            <div className="phase-items">
              <div className="phase-item planned">{t('dmbtGuide.implementation.roadmap.phases.phase3.item1')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderAdvancedFeatures = () => {
    return (
    <div className="dmbt-content advanced-features">
      <div className="dmbt-hero">
        <div className="dmbt-hero-icon">🚀</div>
        <h1>{t('dmbtGuide.advanced.title')}</h1>
        <p className="dmbt-hero-subtitle">
          {t('dmbtGuide.advanced.subtitle')}
        </p>
      </div>
      
      <div className="advanced-intro">
        <p>{t('dmbtGuide.advanced.intro')}</p>
      </div>

      {/* Index de Navigation */}
      <div className="advanced-index">
        <h2>📋 {t('dmbtGuide.advanced.index.title', 'Table des Matières')}</h2>
        <div className="index-grid">
          <a href="#guidance-panel" className="index-item">
            <div className="index-icon">🎯</div>
            <div className="index-content">
              <h4>{t('dmbtGuide.advanced.guidancePanel.title')}</h4>
              <p>{t('dmbtGuide.advanced.index.guidancePanel.description', 'Système de guidance intelligent')}</p>
            </div>
          </a>
          
          <a href="#test-suggestions" className="index-item">
            <div className="index-icon">🤖</div>
            <div className="index-content">
              <h4>{t('dmbtGuide.advanced.testSuggestion.title')}</h4>
              <p>{t('dmbtGuide.advanced.index.testSuggestion.description', 'IA de suggestion de tests')}</p>
            </div>
          </a>
          
          <a href="#playbooks" className="index-item">
            <div className="index-icon">📚</div>
            <div className="index-content">
              <h4>{t('dmbtGuide.advanced.playbooks.title')}</h4>
              <p>{t('dmbtGuide.advanced.index.playbooks.description', 'Guides méthodologiques intelligents')}</p>
            </div>
          </a>
          
          <a href="#code-import" className="index-item">
            <div className="index-icon">📥</div>
            <div className="index-content">
              <h4>{t('dmbtGuide.advanced.codeImport.title')}</h4>
              <p>{t('dmbtGuide.advanced.index.codeImport.description', 'Analyseur de code automatique')}</p>
            </div>
          </a>
          
          <a href="#impact-analysis" className="index-item">
            <div className="index-icon">📊</div>
            <div className="index-content">
              <h4>{t('dmbtGuide.advanced.impactAnalysis.title')}</h4>
              <p>{t('dmbtGuide.advanced.index.impactAnalysis.description', 'IA prédictive d\'impact')}</p>
            </div>
          </a>
          
          <a href="#maturity-scoring" className="index-item">
            <div className="index-icon">🏆</div>
            <div className="index-content">
              <h4>{t('dmbtGuide.advanced.maturityScoring.title')}</h4>
              <p>{t('dmbtGuide.advanced.index.maturityScoring.description', 'Évaluation de maturité DMBT')}</p>
            </div>
          </a>
        </div>
      </div>

      {/* Guidance Panel */}
      <div id="guidance-panel" className="feature-section guidance-panel">
        <div className="feature-header">
          <div className="feature-icon">🎯</div>
          <h2 className="feature-title">{t('dmbtGuide.advanced.guidancePanel.title')}</h2>
        </div>
        <p className="feature-description">
          {t('dmbtGuide.advanced.guidancePanel.description')}
        </p>
        
        <div className="feature-highlights">
          <div className="highlight-card">
            <h4>🧠 {t('dmbtGuide.advanced.guidancePanel.highlights.intelligence.title')}</h4>
            <p>{t('dmbtGuide.advanced.guidancePanel.highlights.intelligence.description')}</p>
          </div>
          <div className="highlight-card">
            <h4>📊 {t('dmbtGuide.advanced.guidancePanel.highlights.recommendations.title')}</h4>
            <p>{t('dmbtGuide.advanced.guidancePanel.highlights.recommendations.description')}</p>
          </div>
          <div className="highlight-card">
            <h4>🎯 {t('dmbtGuide.advanced.guidancePanel.highlights.learning.title')}</h4>
            <p>{t('dmbtGuide.advanced.guidancePanel.highlights.learning.description')}</p>
          </div>
        </div>
        
        <div className="feature-capabilities">
          <h3>{t('dmbtGuide.advanced.guidancePanel.phases.title')}</h3>
          <div className="phases-grid">
            <div className="phase-card" data-phase="Phase 1">
              <h4>🌱 {t('dmbtGuide.advanced.guidancePanel.phases.discovery.title')}</h4>
              <p>{t('dmbtGuide.advanced.guidancePanel.phases.discovery.description')}</p>
              <ul className="phase-features">
                {t('dmbtGuide.advanced.guidancePanel.phases.discovery.features', { returnObjects: true }).map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
            
            <div className="phase-card" data-phase="Phase 2">
              <h4>📈 {t('dmbtGuide.advanced.guidancePanel.phases.expansion.title')}</h4>
              <p>{t('dmbtGuide.advanced.guidancePanel.phases.expansion.description')}</p>
              <ul className="phase-features">
                {t('dmbtGuide.advanced.guidancePanel.phases.expansion.features', { returnObjects: true }).map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
            
            <div className="phase-card" data-phase="Phase 3">
              <h4>🎯 {t('dmbtGuide.advanced.guidancePanel.phases.maturation.title')}</h4>
              <p>{t('dmbtGuide.advanced.guidancePanel.phases.maturation.description')}</p>
              <ul className="phase-features">
                {t('dmbtGuide.advanced.guidancePanel.phases.maturation.features', { returnObjects: true }).map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="feature-capabilities">
          <h3>{t('dmbtGuide.advanced.guidancePanel.algorithms.title')}</h3>
          <div className="capability-grid">
            {t('dmbtGuide.advanced.guidancePanel.algorithms.items', { returnObjects: true }).map((item, index) => (
              <div key={index} className="capability-item">{item}</div>
            ))}
          </div>
        </div>
      </div>

      {/* Test Suggestion Panel */}
      <div id="test-suggestions" className="feature-section test-suggestions">
        <div className="feature-header">
          <div className="feature-icon">🤖</div>
          <h2 className="feature-title">{t('dmbtGuide.advanced.testSuggestion.title')}</h2>
        </div>
        <p className="feature-description">
          {t('dmbtGuide.advanced.testSuggestion.description')}
        </p>
        
        <div className="feature-highlights">
          <div className="highlight-card">
            <h4>✨ {t('dmbtGuide.advanced.testSuggestion.highlights.generation.title')}</h4>
            <p>{t('dmbtGuide.advanced.testSuggestion.highlights.generation.description')}</p>
          </div>
          <div className="highlight-card">
            <h4>💰 {t('dmbtGuide.advanced.testSuggestion.highlights.estimation.title')}</h4>
            <p>{t('dmbtGuide.advanced.testSuggestion.highlights.estimation.description')}</p>
          </div>
          <div className="highlight-card">
            <h4>🎯 {t('dmbtGuide.advanced.testSuggestion.highlights.scoring.title')}</h4>
            <p>{t('dmbtGuide.advanced.testSuggestion.highlights.scoring.description')}</p>
          </div>
        </div>
        
        <div className="feature-capabilities">
            <h3>{t('dmbtGuide.advanced.testSuggestion.capabilities.title')}</h3>
            <div className="capability-grid">
              {t('dmbtGuide.advanced.testSuggestion.capabilities.items', { returnObjects: true }).map((item, index) => (
                <div key={index} className="capability-item">{item}</div>
              ))}
            </div>
        </div>

        <div className="feature-capabilities">
          <h3>{t('dmbtGuide.advanced.testSuggestion.workflow.title')}</h3>
          <div className="import-steps">
            {t('dmbtGuide.advanced.testSuggestion.workflow.steps', { returnObjects: true }).map((step, index) => (
              <div key={index} className="import-step">
                <h4>{step.title}</h4>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Playbooks */}
      <div id="playbooks" className="feature-section playbooks">
        <div className="feature-header">
          <div className="feature-icon">📚</div>
          <h2 className="feature-title">{t('dmbtGuide.advanced.playbooks.title')}</h2>
        </div>
        <p className="feature-description">
          {t('dmbtGuide.advanced.playbooks.description')}
        </p>
        
        <div className="feature-highlights">
          <div className="highlight-card">
            <h4>🎯 {t('dmbtGuide.advanced.playbooks.highlights.adaptation.title')}</h4>
            <p>{t('dmbtGuide.advanced.playbooks.highlights.adaptation.description')}</p>
          </div>
          <div className="highlight-card">
            <h4>📊 {t('dmbtGuide.advanced.playbooks.highlights.tracking.title')}</h4>
            <p>{t('dmbtGuide.advanced.playbooks.highlights.tracking.description')}</p>
          </div>
          <div className="highlight-card">
            <h4>🤝 {t('dmbtGuide.advanced.playbooks.highlights.community.title')}</h4>
            <p>{t('dmbtGuide.advanced.playbooks.highlights.community.description')}</p>
          </div>
        </div>
        
        <div className="feature-capabilities">
          <h3>{t('dmbtGuide.advanced.playbooks.categories.title')}</h3>
          <div className="category-grid">
            <div className="category-card">
              <h4>👥 {t('dmbtGuide.advanced.playbooks.categories.role.title')}</h4>
              <p>{t('dmbtGuide.advanced.playbooks.categories.role.description')}</p>
              <ul className="category-examples">
                {t('dmbtGuide.advanced.playbooks.categories.role.examples', { returnObjects: true }).map((example, index) => (
                  <li key={index}>{example}</li>
                ))}
              </ul>
            </div>
            
            <div className="category-card">
              <h4>🏗️ {t('dmbtGuide.advanced.playbooks.categories.domain.title')}</h4>
              <p>{t('dmbtGuide.advanced.playbooks.categories.domain.description')}</p>
              <ul className="category-examples">
                {t('dmbtGuide.advanced.playbooks.categories.domain.examples', { returnObjects: true }).map((example, index) => (
                  <li key={index}>{example}</li>
                ))}
              </ul>
            </div>
            
            <div className="category-card">
              <h4>⚙️ {t('dmbtGuide.advanced.playbooks.categories.methodology.title')}</h4>
              <p>{t('dmbtGuide.advanced.playbooks.categories.methodology.description')}</p>
              <ul className="category-examples">
                {t('dmbtGuide.advanced.playbooks.categories.methodology.examples', { returnObjects: true }).map((example, index) => (
                  <li key={index}>{example}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="feature-capabilities">
          <h3>{t('dmbtGuide.advanced.playbooks.features.title')}</h3>
          <div className="capability-grid">
            {t('dmbtGuide.advanced.playbooks.features.items', { returnObjects: true }).map((item, index) => (
              <div key={index} className="capability-item">{item}</div>
            ))}
          </div>
        </div>
      </div>

      {/* Code Import */}
      <div id="code-import" className="feature-section code-import">
        <div className="feature-header">
          <div className="feature-icon">📥</div>
          <h2 className="feature-title">{t('dmbtGuide.advanced.codeImport.title')}</h2>
        </div>
        <p className="feature-description">
          {t('dmbtGuide.advanced.codeImport.description')}
        </p>
        
        <div className="feature-highlights">
          <div className="highlight-card">
            <h4>🔍 {t('dmbtGuide.advanced.codeImport.highlights.multiLanguage.title')}</h4>
            <p>{t('dmbtGuide.advanced.codeImport.highlights.multiLanguage.description')}</p>
          </div>
          <div className="highlight-card">
            <h4>🎯 {t('dmbtGuide.advanced.codeImport.highlights.mapping.title')}</h4>
            <p>{t('dmbtGuide.advanced.codeImport.highlights.mapping.description')}</p>
          </div>
          <div className="highlight-card">
            <h4>✨ {t('dmbtGuide.advanced.codeImport.highlights.enrichment.title')}</h4>
            <p>{t('dmbtGuide.advanced.codeImport.highlights.enrichment.description')}</p>
          </div>
        </div>
        
        <div className="feature-capabilities">
          <h3>{t('dmbtGuide.advanced.codeImport.support.title')}</h3>
          <div className="capability-grid">
            {t('dmbtGuide.advanced.codeImport.support.items', { returnObjects: true }).map((item, index) => (
              <div key={index} className="capability-item">{item}</div>
            ))}
          </div>
        </div>

        <div className="feature-capabilities">
          <h3>{t('dmbtGuide.advanced.codeImport.process.title')}</h3>
          <div className="import-steps">
            {t('dmbtGuide.advanced.codeImport.process.steps', { returnObjects: true }).map((step, index) => (
              <div key={index} className="import-step">
                <h4>{step.title}</h4>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Impact Analysis */}
      <div id="impact-analysis" className="feature-section impact-analysis">
        <h2>📊 {t('dmbtGuide.advanced.impactAnalysis.title')}</h2>
        <div className="feature-content">
          <div className="feature-description">
            <p>{t('dmbtGuide.advanced.impactAnalysis.description')}</p>
          </div>
          
          <div className="impact-dimensions">
            <h3>{t('dmbtGuide.advanced.impactAnalysis.dimensions.title')}</h3>
            <div className="dimensions-grid">
              <div className="dimension-card technical">
                <div className="dimension-icon">⚙️</div>
                <h4>{t('dmbtGuide.advanced.impactAnalysis.dimensions.technical.title')}</h4>
                <ul>
                  {t('dmbtGuide.advanced.impactAnalysis.dimensions.technical.items', { returnObjects: true }).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              
              <div className="dimension-card business">
                <div className="dimension-icon">💼</div>
                <h4>{t('dmbtGuide.advanced.impactAnalysis.dimensions.business.title')}</h4>
                <ul>
                  {t('dmbtGuide.advanced.impactAnalysis.dimensions.business.items', { returnObjects: true }).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              
              <div className="dimension-card testing">
                <div className="dimension-icon">🧪</div>
                <h4>{t('dmbtGuide.advanced.impactAnalysis.dimensions.testing.title')}</h4>
                <ul>
                  {t('dmbtGuide.advanced.impactAnalysis.dimensions.testing.items', { returnObjects: true }).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              
              <div className="dimension-card timeline">
                <div className="dimension-icon">⏱️</div>
                <h4>{t('dmbtGuide.advanced.impactAnalysis.dimensions.timeline.title')}</h4>
                <ul>
                  {t('dmbtGuide.advanced.impactAnalysis.dimensions.timeline.items', { returnObjects: true }).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="impact-visualization">
            <h3>{t('dmbtGuide.advanced.impactAnalysis.visualization.title')}</h3>
            <div className="viz-features">
              {t('dmbtGuide.advanced.impactAnalysis.visualization.features', { returnObjects: true }).map((feature, index) => (
                <div key={index} className="viz-item">
                  <strong>{feature.name}:</strong> {feature.description}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* DMBT Maturity Scoring */}
      <div id="maturity-scoring" className="feature-section maturity-scoring">
        <div className="feature-header">
          <div className="feature-icon">🏆</div>
          <h2 className="feature-title">{t('dmbtGuide.advanced.maturityScoring.title')}</h2>
        </div>
        <p className="feature-description">
          {t('dmbtGuide.advanced.maturityScoring.description')}
        </p>
        
        <div className="feature-highlights">
          <div className="highlight-card">
            <h4>📊 {t('dmbtGuide.advanced.maturityScoring.highlights.evaluation.title')}</h4>
            <p>{t('dmbtGuide.advanced.maturityScoring.highlights.evaluation.description')}</p>
          </div>
          <div className="highlight-card">
            <h4>📈 {t('dmbtGuide.advanced.maturityScoring.highlights.progression.title')}</h4>
            <p>{t('dmbtGuide.advanced.maturityScoring.highlights.progression.description')}</p>
          </div>
          <div className="highlight-card">
            <h4>🔮 {t('dmbtGuide.advanced.maturityScoring.highlights.recommendations.title')}</h4>
            <p>{t('dmbtGuide.advanced.maturityScoring.highlights.recommendations.description')}</p>
          </div>
        </div>
        
        <div className="feature-capabilities">
          <h3>{t('dmbtGuide.advanced.maturityScoring.levels.title')}</h3>
          <div className="maturity-levels">
            <div className="maturity-level level-1">
              <div className="level-number">1</div>
              <h4>{t('dmbtGuide.advanced.maturityScoring.levels.level1.title')}</h4>
              <p>{t('dmbtGuide.advanced.maturityScoring.levels.level1.description')}</p>
            </div>
            
            <div className="maturity-level level-2">
              <div className="level-number">2</div>
              <h4>{t('dmbtGuide.advanced.maturityScoring.levels.level2.title')}</h4>
              <p>{t('dmbtGuide.advanced.maturityScoring.levels.level2.description')}</p>
            </div>
            
            <div className="maturity-level level-3">
              <div className="level-number">3</div>
              <h4>{t('dmbtGuide.advanced.maturityScoring.levels.level3.title')}</h4>
              <p>{t('dmbtGuide.advanced.maturityScoring.levels.level3.description')}</p>
            </div>
            
            <div className="maturity-level level-4">
              <div className="level-number">4</div>
              <h4>{t('dmbtGuide.advanced.maturityScoring.levels.level4.title')}</h4>
              <p>{t('dmbtGuide.advanced.maturityScoring.levels.level4.description')}</p>
            </div>
            
            <div className="maturity-level level-5">
              <div className="level-number">5</div>
              <h4>{t('dmbtGuide.advanced.maturityScoring.levels.level5.title')}</h4>
              <p>{t('dmbtGuide.advanced.maturityScoring.levels.level5.description')}</p>
            </div>
          </div>
        </div>

        <div className="feature-capabilities">
          <h3>{t('dmbtGuide.advanced.maturityScoring.criteria.title')}</h3>
          <div className="capability-grid">
            {t('dmbtGuide.advanced.maturityScoring.criteria.items', { returnObjects: true }).map((item, index) => (
              <div key={index} className="capability-item">{item}</div>
            ))}
          </div>
        </div>

        <div className="feature-capabilities">
          <h3>{t('dmbtGuide.advanced.maturityScoring.roadmap.title')}</h3>
          <div className="capability-grid">
            {t('dmbtGuide.advanced.maturityScoring.roadmap.items', { returnObjects: true }).map((item, index) => (
              <div key={index} className="capability-item">{item}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
    );
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'overview': return renderOverview();
      case 'methodology': return renderMethodology();
      case 'nodes': return renderNodes();
      case 'relations': return renderRelations();
      case 'workflow': return renderWorkflow();
      case 'patterns': return renderPatterns();
      case 'benefits': return renderBenefits();
      case 'implementation': return renderImplementation();
      case 'advanced': return renderAdvancedFeatures();
      default: return renderOverview();
    }
  };

  return (
    <div className="dmbt-overlay" style={{ display: isOpen ? 'flex' : 'none' }}>
      <div className="dmbt-modal">
        {/* Header moderne du modal */}
        <div className="dmbt-header">
          <div className="dmbt-header-content">
            <div className="dmbt-header-icon">🧠</div>
            <div className="dmbt-header-text">
              <h2>Dynamic Model-Based Testing</h2>
              <div className="subtitle">Guide interactif et méthodologie avancée</div>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="dmbt-close-btn"
            aria-label="Fermer le guide"
          >
            ✕
          </button>
        </div>

        {/* Contenu du modal */}
        <div className="dmbt-guide" style={{ flex: 1, overflow: 'hidden' }}>
          <div className="dmbt-tabs">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`dmbt-tab ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span className="tab-icon">{tab.icon}</span>
                <span className="tab-label">{tab.label}</span>
              </button>
            ))}
          </div>
          
          <div className="dmbt-content-wrapper">
            {renderContent()}
          </div>

        
        </div>
      </div>
    </div>
  );
};

export default DMBTGuide;
